    import React, { useContext, useEffect, useState } from 'react'
    import { actionPermission, errorSchema, utils } from 'helper'
    import { CommonInput, CommonModal, CustomSelect } from 'components'
    import StorageService from 'utils/StorageServices/StorageServices'
    import { getBranchDropdownListData } from '_services/dropdownServices/dropdownService' // getConsignorDropdownListData
    // import { fetchConsignorDetailsData } from '_services/accountsServices/consignorServices'
    import { getEwayBillLrData } from '_services/accountsServices/ewayBillServices'
    import toast from 'react-hot-toast'
    import { UserContext } from 'context'
    import EbillExtentionModal from 'modals/EbillExtentionModal'
    import { constant } from 'constants/constant'

    const formObj = {
        // party: {},
        branch_id: {},
        eway_bill_no: '',
    }

    const AddEwayBillModal = (props) => {

        let { isOpen, fetchNextModal, manualNextModal, closeModal, addButtonAction, showPrefield, secondSubmit, isAddLrLater, filledLocation = {}, isOpenModelClose, disableBranchConsignor = false } = props;
        const { permissionModal, setEwayBillInitialData } = useContext(UserContext)
        const [formValue, setFormValue] = useState(formObj);
        const [formError, setFormError] = useState({});
        const [loading, setLoading] = useState(false);
        // const [consignorList, setConsignorList] = useState([]);
        const [dropdownBranchList, setDropdownBranchList] = useState([]);
        const [permissionError, setPermissionError] = useState(false);

        const gst_number = localStorage.getItem("gst_number");
        const [modalConfig, setModalConfig] = useState({
            isOpen: false,
            messageType: null,
            templateId: null,
            templateData: {}
        });

        // const getDropdownDataConsignorList = async () => {
        //     try {
        //         let object = {
        //             company_id: StorageService.getCompanyId(),
        //             search: '',
        //         }
        //         const res = await getConsignorDropdownListData(object);
        //         setLoading(false);
        //         if (res?.responseCode == 200) {
        //             setConsignorList(res?.data?.consignor_list)
        //         }
        //     } catch (error) {
        //         // throw error;
        //     }
        // }

        const getDropdownDataBranchList = async () => {
            try {
                let object = {
                    company_id: StorageService.getCompanyId(),
                    firm_id: StorageService.getFirmId(),
                    search: "",
                };
                const res = await getBranchDropdownListData(object);
                if (res?.responseCode == 200) {
                    let data = res?.data?.branch_list?.reverse()?.map((el) => {
                        return {
                            label: el?.branch,
                            value: el?._id,
                            is_eway_integration: el?.is_eway_integration,
                            firm_id: el?.firm_id
                        }
                    })
                    setDropdownBranchList(data);
                    setLoading(false);
                }
                setLoading(false);
            } catch (error) {
                setLoading(false);
            }
        };

        useEffect(() => {
            setLoading(true);
            // getDropdownDataConsignorList();
            getDropdownDataBranchList();
        }, [])

        const onhandleSelect = async (item, name) => {
            if (name === 'branch_id') {
                if (item?.is_eway_integration) {
                    setPermissionError(false);
                } else {
                    setPermissionError(true);
                }
            }
            const stateObj = { ...formValue, [name]: item };
            setFormValue(stateObj);

            if (!utils.isObjectKeyEmpty(formError)) {
                const validationResult = await utils.checkFormError(stateObj, errorSchema.createEwayBillModalSchema);
                if (validationResult === true) {
                    setFormError({});
                } else {
                    setFormError(validationResult);
                }
            }
        };

        // const singleConsignorData = async () => {
        //     setLoading(true);
        //     try {
        //         let object = {
        //             consignor_id: formValue?.party?.value,
        //             company_id: StorageService.getCompanyId(),
        //         }
        //         const res = await fetchConsignorDetailsData(object);
        //         if (res?.responseCode == 200) {
        //             nextModal(res?.data?.consignor);
        //             setLoading(false);
        //         } else {
        //             setLoading(false);
        //         }
        //     } catch (error) {
        //         setLoading(false);
        //     }
        // }

        const fetchEwayBillData = async () => {
            try {
                let object = {
                    // consignor_id: formValue?.party?.value ? formValue?.party?.value : '',
                    branch_id: formValue?.branch_id?.value ? formValue?.branch_id?.value : '',
                    company_id: StorageService.getCompanyId(),
                    ewbNo: formValue?.eway_bill_no ? formValue?.eway_bill_no?.toString() : null,
                }
                // let object2 = {
                //     consignor_id: formValue?.party?.value,
                //     company_id: StorageService.getCompanyId(),
                // }
                const ewayBillResponse = await getEwayBillLrData(object);
                // const consignorResponse = await fetchConsignorDetailsData(object2);

                if (ewayBillResponse?.responseCode == 200) { // && consignorResponse?.responseCode == 200
                    // nextModal({ eway_bill: ewayBillResponse?.data, isEditLr: true }); //  ...consignorResponse?.data?.consignor,
                    fetchNextModal({ eway_bill: ewayBillResponse?.data, isEditLr: true })
                    isOpenModelClose(false);
                    // StorageService.setGstNumber('');
                    setFormValue({});
                    setLoading(false);
                } else {
                    if (ewayBillResponse?.responseMessage) {
                        toast.error(`${ewayBillResponse?.responseMessage}`);
                    }
                    setLoading(false);
                }
            } catch (error) {
                setLoading(false);
                // toast.error(`Eway bill data not found`);
            }
        }


        const validationFromPermission = () => {
            if (!formValue?.branch_id?.is_eway_integration) {
                setPermissionError(true)
            } else {
                setPermissionError(false)
                setLoading(true);
                fetchEwayBillData();
                setEwayBillInitialData({ ...formValue, is_eway_fetch: true });
                setFormError("");
            }
        }

        const handlePermissionCall = async (e) => {
            e.preventDefault();

            await actionPermission({
                company_id: StorageService.getCompanyId(),
                type: constant?.USABILITY_CONFIG_TYPES?.EWAY_FETCH,
                onSuccess: () => validationFromPermission(),
                setModalConfig, // Pass setter
            });
        };



        const handleSubmit = async (event, is_eway) => {
            event.preventDefault();
            const validationResult = await utils?.checkFormError(formValue, errorSchema.createEwayBillModalSchema);
            if (utils?.isObjectKeyEmpty(validationResult)) {
                // if (is_eway === 'add_manually') {
                //     setEwayBillInitialData({ ...formValue, is_eway_fetch: false });
                //     manualNextModal(true)
                //     // singleConsignorData();
                //     isOpenModelClose(false);
                // } 
                if (is_eway === 'add_manually') {
        setEwayBillInitialData({ ...formValue, is_eway_fetch: false });
        manualNextModal(formValue?.eway_bill_no || "");  // ← directly pass, context async hai
        isOpenModelClose(false);
    }
                else {
                    handlePermissionCall(event)

                }
            } else {
                setFormError(validationResult);
                setLoading(false);
            }
        }

        // useEffect(() => {
        //     if (consignorList?.length > 0 && showPrefield) {
        //         setFormValue((s) => ({
        //             ...s,
        //             party: consignorList?.map((el) => {
        //                 return {
        //                     label: el?.name,
        //                     value: el?._id,
        //                 }
        //             })[0],
        //         }))
        //     }
        // }, [consignorList, showPrefield])

        useEffect(() => {
            // if (consignorList?.length > 0 && consignorList?.length === 1) {
            //     setFormValue((s) => ({
            //         ...s,
            //         party: consignorList?.map((el) => {
            //             return {
            //                 label: el?.name,
            //                 value: el?._id,
            //             }
            //         })[0],
            //     }))
            // }
            if (dropdownBranchList?.length > 0 && dropdownBranchList?.length === 1) {
                setFormValue((s) => ({
                    ...s,
                    branch_id: dropdownBranchList[0]
                }))
            }
        }, [dropdownBranchList]) // consignorList

        const buttonActionHandler = () => {
            addButtonAction(true);
            isOpenModelClose(false);
        }

        const addEwayBillManually = () => {

        }

        const propsLrModalInhance = {
            ...props,
            isLoadding: loading,
            disabled: loading || permissionError,
            onSubmit: (e) => handleSubmit(e),
            modalZIndex: permissionModal ? -1 : '',
            closeModal: (e) => handleSubmit(e, 'add_manually'),
            cancelButtonTitle: 'Add Manually'
        }

        const handleOnChange = async (name, value) => {
            const stateObj = { ...formValue, [name]: value };
            setFormValue(stateObj);

            if (!utils.isObjectKeyEmpty(formError)) {
                const validationResult = await utils.checkFormError(stateObj, errorSchema.createEwayBillModalSchema);
                if (validationResult === true) {
                    setFormError("");
                } else {
                    setFormError(validationResult);
                }
            }
        };

        useEffect(() => {
            setFormValue((s) => ({
                ...s,
                // party: isOpen?.consignor_id?._id ? {
                //     label: isOpen?.consignor_id?.name,
                //     value: isOpen?.consignor_id?._id,
                // } : {},
                branch_id: isOpen?.branch_id?._id ? {
                    label: isOpen?.branch_id?.branch,
                    value: isOpen?.branch_id?._id,
                    is_eway_integration: isOpen?.branch_id?.is_eway_integration
                } : {},
                eway_bill_no: isOpen?.eway_bill_number ? isOpen?.eway_bill_number : (isOpen?.ewbNo ? isOpen?.ewbNo : null),
            }))
        }, [isOpen])

        let ebillExpProps = {
            isOpen: modalConfig.isOpen,
            closeModal: () => setModalConfig(prev => ({ ...prev, isOpen: false })),
            onSubmit: (e) => setModalConfig(prev => ({ ...prev, isOpen: false })),
            modalMainClass: " _dashCommon_Modal __actionPermissionModal _smModal",
            headerPart: true,
            floatCrossBtn: true,
            submitTitle: "Send Enquiry",
            messageType: modalConfig.messageType,
            templateId: modalConfig.templateId,
            templateData: modalConfig.templateData
        };

        return (
            <>
                <CommonModal {...propsLrModalInhance}>
                    <div className='addItem_body mt-2'>
                        <div className='colFlx'>
                            {/* <div className='singleDiv'>
                                <CustomSelect
                                    options={consignorList?.map((el) => {
                                        return {
                                            label: el?.name,
                                            value: el?._id,
                                            consignor_code: el?.consignor_code,
                                            template_no: el?.template_no,
                                        }
                                    })}
                                    name="party"
                                    label="Select Party"
                                    placeholder="Select Party"
                                    isAddButton={true}
                                    addButtonAction={(e) => buttonActionHandler(e)}
                                    value={formValue?.party?.value ? formValue?.party : {}}
                                    error={formError["party.label"]}
                                    // error={!!(typeof formError === "object") ? formError?.party : ""}
                                    onSelect={(data) => onhandleSelect(data, 'party')}
                                    disabled={disableBranchConsignor ? true : false}
                                />
                            </div> */}
                            <div className='singleDiv'>
                                <CustomSelect
                                    options={dropdownBranchList}
                                    name="branch_id"
                                    label="Select Branch"
                                    placeholder="Select Branch"
                                    isAddButton={false}
                                    value={formValue?.branch_id?.value ? formValue?.branch_id : {}}
                                    error={formError["branch_id.label"]}
                                    onSelect={(data) => onhandleSelect(data, 'branch_id')}
                                    disabled={disableBranchConsignor ? true : false}
                                />
                                {permissionError ? (
                                    <span className="input_drop_error">
                                        This branch has no Eway Bill Integration
                                    </span>
                                ) : <></>}
                            </div>
                            <div className='singleDiv'>
                                <CommonInput
                                    type="text"
                                    label='Eway Bill Number '
                                    placeholder='Eway Bill Number e.g 621906815556'
                                    name='eway_bill_no'
                                    maxLength="12"
                                    onInput={utils.maxLengthCheck}
                                    value={formValue.eway_bill_no}
                                    focus={!!(typeof formError === "object" && formError?.eway_bill_no)}
                                    error={!!(typeof formError === "object") ? formError?.eway_bill_no : ""}
                                    onChange={(e) => utils.handleOpeningBalanceInputChange(e, handleOnChange)}
                                />
                            </div>
                        </div>
                    </div>
                </CommonModal>

                {modalConfig.isOpen && <EbillExtentionModal

                    {...ebillExpProps}

                />}
            </>
        )
    }

    export default React.memo(AddEwayBillModal);